import { render, staticRenderFns } from "./App.vue?vue&type=template&id=01cd7743&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Ampps/www/mwst-rechner-pwa/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VAvatar } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
installComponents(component, {VApp,VAvatar,VCard,VFlex,VImg,VLayout,VSnackbar})


/* vuetify-loader */
import installDirectives from "!C:/Ampps/www/mwst-rechner-pwa/node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import { Resize } from 'vuetify/lib/directives'
installDirectives(component, {Resize})
